import React, { Fragment } from "react";
import { Card, Row, Col, Button } from 'react-bootstrap';
import '../../../../../styles/diario.scss'
import moment from "moment";

const Ato = (props) => {

    moment.locale('pt');
    moment.updateLocale('pt', {
        months: [
            "Janeiro", "Fevereiro", "Março", "Abril", "Maio", "Junho", "Julho",
            "Agosto", "Setembro", "Outubro", "Novembro", "Dezembro"
        ],
        weekdays: [
            "Domingo", "Segunda", "Terça", "Quarta", "Quinta", "Sexta", "Sábado"
        ]
    });

    const deletar = async (id) => {
        props.deletar(id)
        await props.fetchAtosIn()
    }

    const editar = async (id) => {
        props.editar(id)
    }
    const setArquivo = async (id) => {
        props.arquivo(id)
    }

    return (
        <Fragment>
            <Col>
                <Card className='card-list'>
                    <Card.Body>
                        <Card.Title className="cabeca-card" key={props.key}>Ato {props.ato.categoria} Nº{props.ato.numAto} de {moment(props.ato.dataAto).utc(false).format('dddd, DD [de] MMMM [de] YYYY')}</Card.Title>
                    </Card.Body>
                    <hr />
                    <Button type="button" className="botao-leis" onClick={() => editar(props.ato._id)} variant='primary'>Editar</Button>
                    <Button type='button' className="botao-leis" onClick={() => setArquivo(props.ato._id)} variant='primary'>Mudar Arquivo</Button>
                    <Button type='button' className="botao-leis" onClick={() => deletar(props.ato._id)} variant='danger'>Excluir</Button>
                </Card>
            </Col>
        </Fragment >)
}

export default Ato;